import React, { useState, useEffect } from "react";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import InputText from "../../Form/InputText";
import CheckboxR from "../../Form/CheckboxR";
import CustomButton from "../../UI/Button";
import styleConstants from "../../../constants/styleConstants";
import Tooltip from "@material-ui/core/Tooltip";
import { updNotify } from "../../../pages/notifyUsers/api";
import { useDispatch } from "react-redux";
import { setShowModal } from "../../../services/redux/actions/app-actions";
import { emojiToUnicodeEscapes, unicodeEscapesToEmoji } from "utils/emojis";
import { trimEmptyLines } from "utils/text";


const useStyles = makeStyles({
  dialogTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 24px",
    "& h2": {
      fontSize: 18,
      fontWeight: 600,
    },
  },
  closeButton: {
    color: "#9194A9",
  },
  inputs_block: {
    display: "grid",
    padding: "10px 0",
    "& input": {
      width: 552,
    },
  },
  description: {
    color: "#494C62",
    border: "none",
    borderRadius: 4,
    outline: "none",
    resize: "none",
    width: "100%",
    marginBottom: 10,
    padding: 10,
  },
  actions: {
    padding: "8px 24px 16px",
    justifyContent: "flex-end",
  },
});

function NotifyModal({ open, onClose, notification = null, onSuccess }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [value, setValue] = useState({ current_day: false });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (notification) {
      setValue({
        notice_id: notification.notice_id,
        head_text: notification.head_text,
        body_text: notification.body_text,
        current_day: notification.current_day,
      });
    } else {
      setValue({ current_day: false });
    }
  }, [notification, open]);

  const handleChange = (e, v, name) => {
    const key = name ? name : e.target.name;
    const valueToSet =
      key === "check" ? e.target.checked : v ? v : e.target.value;
    setValue({
      ...value,
      [key === "check" ? "current_day" : key]: valueToSet,
    });

    // Clear error for the field being changed
    if (errors[key] && key !== "check") {
      setErrors({
        ...errors,
        [key]: null,
      });
    }
  };

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!value.head_text || value.head_text.trim() === "") {
      newErrors.head_text = "Заголовок обязателен";
    }
    if (!value.body_text || value.body_text.trim() === "") {
      newErrors.body_text = "Описание обязательно";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = () => {
    if (!validateForm()) {
      return;
    }

    const preparedValue = {
      ...value,
      head_text: trimEmptyLines(emojiToUnicodeEscapes(value.head_text || "")),
      body_text: trimEmptyLines(emojiToUnicodeEscapes(value.body_text || "")),
    };

    setLoading(true);
    updNotify(preparedValue)
      .then((res) => {
        if (onSuccess) {
          onSuccess(res);
        }
        dispatch(setShowModal(false));
        onClose();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <form>
        <DialogTitle disableTypography className={classes.dialogTitle}>
          <Box component="h2">
            {notification ? "Редактировать уведомление" : "Создать уведомление"}
          </Box>
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box className={classes.inputs_block}>
            <InputText
              required
              name="head_text"
              label="Заголовок"
              fullWidth={true}
              value={unicodeEscapesToEmoji(value["head_text"]) || ""}
              onChange={handleChange}
              error={!!errors.head_text}
              helperText={errors.head_text}
            />
            <InputText
              required
              name="body_text"
              label="Описание"
              multiline
              maxRows={8}
              fullWidth={true}
              value={unicodeEscapesToEmoji(value["body_text"]) || ""}
              onChange={handleChange}
              error={!!errors.body_text}
              helperText={errors.body_text}
            />
            <Tooltip title="Данное уведомление будет показано только в течении сегодняшнего дня">
              <div>
                <CheckboxR
                  name="check"
                  label="Однодневное уведомление"
                  onChange={handleChange}
                  value={value["current_day"] || false}
                />
              </div>
            </Tooltip>
          </Box>
        </DialogContent>
        <DialogActions className={classes.actions}>
          <CustomButton
            btnText={"Отмена"}
            bgColor={"#fff"}
            textColor={"#000"}
            onClick={onClose}
            style={{ marginRight: 10 }}
          />
          <CustomButton
            btnText={"Сохранить"}
            bgColor={styleConstants.primaryColor}
            onClick={handleSave}
            loading={loading}
          />
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default NotifyModal;